import React from 'react';
import { EXTENDED_FIELDS, SECTIONS } from '@/data/extendedProfileFields';

export function hasExtendedProfile(profile) {
  if (!profile) return false;
  return EXTENDED_FIELDS.some(f => {
    const v = profile[f.key];
    return !(v === null || v === undefined || v === '');
  });
}

/**
 * Read-only display of the 24 optional profile fields.
 * Skips any field where value is null / undefined / empty string.
 * If no fields are filled at all, renders nothing.
 */
export function ExtendedProfileView({ profile, lang = 'id', className = '' }) {
  if (!profile) return null;
  // Group filled fields by section
  const bySection = new Map(SECTIONS.map(s => [s.key, []]));
  for (const f of EXTENDED_FIELDS) {
    const v = profile[f.key];
    if (v === null || v === undefined || v === '') continue;
    bySection.get(f.section).push({ field: f, value: v });
  }
  const nonEmpty = SECTIONS.filter(s => bySection.get(s.key).length > 0);
  if (nonEmpty.length === 0) return null;

  const isID = lang !== 'en';
  const yn = (v) => v === true ? (isID ? 'Ya' : 'Yes') : v === false ? (isID ? 'Tidak' : 'No') : '—';

  const renderValue = (field, value) => {
    if (field.type === 'yesno') return yn(value);
    if (field.type === 'slider') return <span className="tabular-nums">{value}/10</span>;
    if (field.type === 'number' && field.unit) return <span className="tabular-nums">{value} {field.unit}</span>;
    return <span className="break-words">{String(value)}</span>;
  };

  return (
    <div className={`space-y-3 ${className}`} data-testid="extended-profile-view">
      {nonEmpty.map(sec => (
        <div key={sec.key}>
          <div className="text-[10px] font-bold uppercase tracking-wider t-text-muted mb-1.5">
            {isID ? sec.label_id : sec.label_en}
          </div>
          <div className="grid grid-cols-2 gap-x-3 gap-y-1.5">
            {bySection.get(sec.key).map(({ field, value }) => (
              <div key={field.key} className="text-xs" data-testid={`view-${field.key}`}>
                <div className="t-text-muted leading-tight">{isID ? field.label_id : field.label_en}</div>
                <div className="t-text font-medium leading-tight">{renderValue(field, value)}</div>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
